// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"Popover_contentWrapper__2DD45"};